import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, render, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { marked } from 'marked';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import purify from '../../node_modules/dompurify/dist/purify.es.js';
import css_248z from './markdown.styles.css.js';

/**
 * Markdown Component.
 *
 * @element ht-markdown
 * @csspart markdown The markdown content container.
 */
let HTMarkdown = class HTMarkdown extends LitElement {
    constructor() {
        super(...arguments);
        this.content = '';
        this.sanitize = true;
        this.chart = null;
    }
    get markdownContent() {
        if (!this.content)
            return '';
        const renderer = new marked.Renderer();
        renderer.heading = function ({ tokens, depth }) {
            const text = this.parser.parseInline(tokens);
            return `<h${depth} class="headline${depth > 4 ? 4 : depth}">${text}</h${depth}>`;
        };
        renderer.paragraph = function ({ tokens }) {
            const text = this.parser.parseInline(tokens);
            return `<p class="paragraph2">${text}</p>`;
        };
        let html = marked.parse(this.content, { renderer });
        if (this.chart) {
            html = html.replace('{{CHART}}', '<div id="__chart-placeholder__"></div>');
        }
        return this.sanitize ? purify.sanitize(html) : html;
    }
    firstUpdated() {
        var _a;
        if (this.chart) {
            const placeholder = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#__chart-placeholder__');
            if (placeholder) {
                render(this.chart, placeholder);
            }
        }
    }
    render() {
        return html `
      <div class="markdown" part="markdown">
        ${unsafeHTML(this.markdownContent)}
      </div>
    `;
    }
};
HTMarkdown.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], HTMarkdown.prototype, "content", void 0);
__decorate([
    property({ type: Boolean })
], HTMarkdown.prototype, "sanitize", void 0);
__decorate([
    property({ attribute: false })
], HTMarkdown.prototype, "chart", void 0);
HTMarkdown = __decorate([
    customElement('ht-markdown')
], HTMarkdown);
var HTMarkdown$1 = HTMarkdown;

export { HTMarkdown$1 as default };
//# sourceMappingURL=markdown.js.map
